import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import LogowanieService from "../../logowanie/LogowanieService";
import ZmianaHaslaForm from "./components/ZmianaHaslaForm";



export default class DanekontaTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zalogowany: LogowanieService.pobierzZalogowanego(),
        };
    }

    componentWillReceiveProps(np){
    }

    render() {

        return (
            <div>
                {
                    Boolean(this.props.user) ?
                        <Row>
                            <Col xs={12} lg={5}>
                                <fieldset>
                                    <div className={'fieldset-label'}>Dane o koncie</div>
                                    <Row>
                                        <Col xs={12} lg={4}>
                                            <i className={'fa fa-user'} style={{marginRight: '10px'}}></i>
                                            <span>{this.state.zalogowany.login ? this.state.zalogowany.login : ''}</span>
                                        </Col>
                                        <Col xs={12} lg={8}>
                                            <i className={'fa fa-address-card-o'} style={{marginRight: '10px'}}></i>
                                            <span>{this.props.user.imieNazwisko ? (this.props.user.imieNazwisko) : ''}</span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} lg={12}>
                                            <i className={'fa fa-user-secret'} style={{marginRight: '4px'}}></i> <span>
                                            {
                                                this.props.user.role ?
                                                    <span>
                                                {this.props.user.role.map(item => {
                                                    return (item.rola).substr(5,item.rola.length-1) + ', '
                                                })}</span>
                                                    : ''
                                            }
                                                    </span>
                                        </Col>
                                    </Row>
                                </fieldset>
                            </Col>
                        </Row>
                        :
                        ''
                }

                <Row>
                    <Col xs={12} lg={5}>
                       <ZmianaHaslaForm zalogowany={this.state.zalogowany}/>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/home/danekonta/DanekontaTabContainer.js